// re.rejouis.fr — RECHERCHE (search-first) branchée sur le vrai catalogue
// éligible via la fonction Netlify `catalog`. Le champ + les résultats sont
// portés par le composant partagé RechercheModele (réutilisé aussi sur la home).
import { useState } from 'react';
import { EcranHeader, Icons, Illus } from '../components/ui.jsx';
import RechercheModele from '../components/RechercheModele.jsx';
import PanierBar from '../components/PanierBar.jsx';
import { REFERENCEMENT_ACTIF } from '../lib/flags.js';

export default function Catalogue({ go, panier, params, onChoisir }) {
  const [q, setQ] = useState(params?.q || ''); // pré-rempli depuis la home (Entrée ou « Voir les N résultats »)
  const enRecherche = q.trim().length >= 2;

  return (
    <div className="no-scrollbar" style={{ height: '100%', overflow: 'auto', padding: '16px 0 110px' }}>
      <EcranHeader titre="Rechercher un modèle" onBack={() => go('accueil')} />

      <RechercheModele go={go} panier={panier} onChoisir={onChoisir} q={q} setQ={setQ} autoFocus={params?.focus} />

      {!enRecherche ? (
        <>
          <div style={{ padding: '10px 16px 0' }}>
            <button onClick={() => go('scan')} className="rep-btn" style={{ justifyContent: 'center', minHeight: 50, color: 'var(--rouge)' }}>
              <Illus nom="photo" size={30} /> L’identifier par photo
            </button>
          </div>

          {/* Toujours accessibles, en bas */}
          <div style={{ padding: '18px 16px 0', display: 'flex', flexDirection: 'column', gap: 8 }}>
            <hr className="hr" />
            {REFERENCEMENT_ACTIF ? (
            <button onClick={() => go('referencement', {})} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 4px', textAlign: 'left' }}>
              <Illus nom="ajout" size={40} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13.5 }}>Mon modèle n’est pas là</div>
                <div style={{ fontSize: 12, color: 'var(--stone)' }}>Demande de référencement</div>
              </div>
              <Icons.chev size={16} style={{ color: 'var(--stone)' }} />
            </button>
            ) : null}
            <button onClick={() => go('lot')} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 4px', textAlign: 'left' }}>
              <Illus nom="lot" size={40} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13.5 }}>J’en ai beaucoup (un lot)</div>
                <div style={{ fontSize: 12, color: 'var(--stone)' }}>Jouets sans référence connue, dès 1 jouet</div>
              </div>
              <Icons.chev size={16} style={{ color: 'var(--stone)' }} />
            </button>
          </div>
        </>
      ) : null}

      <PanierBar panier={panier} go={go} />
    </div>
  );
}
